<script setup lang="ts">
import type { ButtonProps } from '~/components/Button.vue'
import { twMerge } from 'tailwind-merge'

defineProps<Omit<ButtonProps, 'size'>>()
</script>

<template>
  <Button v-bind="$props" :class="twMerge(String($attrs.class), 'hidden md:flex')" size="medium">
    <slot />
  </Button>
  <Button v-bind="$props" :class="twMerge(String($attrs.class), 'md:hidden')" size="small">
    <slot />
  </Button>
</template>
